import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Tab from 'react-bootstrap/Tab';
import CustomNavbar from '../../components/navbar';
import Sidebar from '../../components/sidebar';
import MainContent from '../../components/mainContent';
import Row from 'react-bootstrap/Row';
import BlogList from '../Painel/blogList';
import CatBlog from '../Painel/cateBlog';

const BlogIndex = () => {

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [key, setKey] = useState('categoria');
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
        <div className="dashboard-container">
            {/* Sidebar */}
            <Sidebar isOpen={isSidebarOpen} />
            {/* Área de conteúdo */}
            <div className={`main-area ${isSidebarOpen ? 'sidebar-open' : ''}`}>
                <CustomNavbar toggleSidebar={toggleSidebar} />
                {/* Conteúdo principal */}
                <MainContent>
                    <Container>
                        <Row>
                            <h2 className='text-center titulo-pagina'><i style={{ color: '#ff7a00' }} className="fa-solid fa-blog"></i> BLOG</h2>
                            <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                                <div className='nav-avaliacao'>
                                    <Navbar expand="lg">
                                        <Nav className="mr-auto">
                                            <Nav.Link eventKey="categoria" onClick={() => setKey('categoria')}><i className="fas fa-folder"></i> Categoria</Nav.Link>
                                            <Nav.Link eventKey="blog" onClick={() => setKey('blog')}><i className="fas fa-book-open"></i> Post</Nav.Link>
                                        </Nav>
                                    </Navbar>
                                </div>
                            </Tab.Container>
                            <Tab.Content>
                                <Tab.Pane eventKey="categoria" active={key === 'categoria'}>
                                    {key === 'categoria' && <CatBlog />}
                                </Tab.Pane>
                                <Tab.Pane eventKey="blog" active={key === 'blog'}>
                                    {key === 'blog' && <BlogList />}
                                </Tab.Pane>
                            </Tab.Content>
                        </Row>
                    </Container>
                </MainContent>
            </div>
        </div >
    );
};

export default BlogIndex;
